import "../scss/style.scss";

import Lenis from '@studio-freight/lenis'
import gsap from "gsap";
import { CustomEase } from "gsap/CustomEase.js";
import axios from 'axios';
import {Curtains, Plane, Vec2} from 'curtainsjs';
//import SimplexNoise from 'simplex-noise';
import { createNoise2D } from 'simplex-noise';

gsap.registerPlugin(CustomEase);
CustomEase.create("cubic-1", ".25,.1,.25,1");

import vs from '../shaders/vertex.glsl'
import vs2 from '../shaders/vertex2.glsl'
import fs from '../shaders/fragment.glsl'
import fs2 from '../shaders/fragment2.glsl'

import LogoSVG from '../images/logo2.svg';
import FacebookSVG from '../images/facebook.svg';
import InstagramSVG from '../images/instagram.svg';

import ArrowSVG from '../images/arrow.svg';
import HashSVG from '../images/hash.svg';
import HeartSVG from '../images/heart.svg';
import MapSVG from '../images/map.svg';
//import ThumbSVG from '../images/thumb.svg';
import NewsletterSVG from '../images/newsletter.svg';
import AwdSVG from '../images/awd.svg';
//import CheckSVG from '../images/check.svg';
import Loader1SVG from '../images/loader-1.svg';
import Loader2SVG from '../images/loader-2.svg';
import LightningSVG from '../images/lightning.svg';

let winsize = {width: window.innerWidth, height: window.innerHeight};

function calcWinsize(){
	return {width:window.innerWidth, height:window.innerHeight}
}

const _isTablet = () => {
	let ratio = window.devicePixelRatio || 1;
	let screen = {
			width : window.screen.width * ratio,
			height : window.screen.height * ratio
	};
	if(
		(screen.width === 2048 && winsize.width === 1024) || //iPad Pro Portrait (sia realtà sia ispezionatore)
		(screen.width === 1536 && screen.height === 2048)  //Forse iPad reale Portrait e Landscape e iPad ispezionatore portrait
	){
		return true;
	}
	else {
		return false;
	}
}
export let isTablet = _isTablet();

const _isMobile =  () => {
	if(winsize.width <= 1023){
		return true;
	}
	else{
		return false;
	}
}
export let isMobile = _isMobile();

//Anche iPad Pro Landscape
const _isAllTablet = () => {
	let response;
    let ratio = window.devicePixelRatio || 1;
    let screen = {
			width : window.screen.width * ratio,
			height : window.screen.height * ratio
    };
		//alert('Screen' + screen.width+ ' | w' + winsize.width);

    //!DECOMMENTARE IN PRODUZIONE, COMMENTARE QUELLO SOTTO
    //!iPad Pro: nella realtà window.screen.width è SEMPRE == a 1024, anche quando è LANDSCAPE, quindi QUESTO if è quello corretto
    if(
    	(screen.width === 2048 && winsize.width === 1024) || //iPad Pro Portrait //*iPad Portrait nella realtà
    	(screen.width === 1640 && winsize.width === 820) || //iPad Air Portrait //*iPad Portrait nella realtà
    	(screen.width === 1668 && winsize.width === 834) || //iPad Pro 11 //*iPad Portrait nella realtà
        //Se screen.height stampa 2732,questo if varrebbe per iPad pro landscape reale
    	(screen.width === 2048 && screen.height === 2732) || //!ispezionatore iPad Pro Portrait (serve solo quando si debugga col simulatore di Chrome)
    	(screen.width === 2048 && winsize.width === 1366) || //iPad Pro Landscape //*iPad Landscape nella realtà
    	(screen.width === 1640 && winsize.width === 1180) || //Pad Air Landscape //*iPad Landscape nella realtà
    	(screen.width === 1668 && winsize.width === 1194) || //iPad Pro 11 //*iPad Landscape nella realtà
    	(screen.width === 2732 && screen.height === 2048) || //!ispezionatore iPad Pro Landscape (serve solo quando si debugga col simulatore di Chrome)
    	(screen.width === 1536 && screen.height === 2048) || //iPad
    	(screen.width === 2048 && screen.height === 1536)){
    	response = true;
    }
    else {
    	response = false;
    }

    return response;
}

export let isAllTablet = _isAllTablet();

const _isAllMobileDevices =  () => {
	if(winsize.width <= 1023 || isAllTablet){
		return true;
	}
	else{
		return false;
	}
}
export let isAllMobileDevices = _isAllMobileDevices();

window.addEventListener('resize', () => {
	winsize = calcWinsize();
	isAllMobileDevices = _isAllMobileDevices();
	isMobile = _isMobile();
	isTablet = _isTablet();
	isAllTablet = _isAllTablet()
});

export const introLoader = (scroll) => {
	return new Promise((resolve, reject) => {
		let loader = document.getElementById('loader');
		let circle = loader.querySelector('.canvas--circle')
		let logo = loader.querySelector('.logo')
		//logo.innerHTML = LightningSVG;
		new CircleCanvas(circle, circle.dataset.stroke, false, 0.09); //0.09
		gsap.to(circle, { duration: 0, scale: 0.3})

		gsap.to(loader, { duration: 3, backgroundColor: '#f3f3f1', ease: 'cubic-1'})
		//gsap.to(logo.querySelector('svg'), { duration: 3, fill: '#f3f3f1', ease: 'cubic-1'})
		gsap.to(circle, { duration: 1, scale: 1, autoAlpha: 1, ease: 'back.out(2)', onComplete: () => {
			scroll.scrollTo(0, { immediate: true })
			scroll.stop()
			//gsap.to(logo, { duration: 1, delay: 1, scale: 0.7, autoAlpha: 0, ease: 'cubic-1' })
			gsap.to(circle, { duration: 1, delay: 1, scale: 10, ease: 'power4.in', onComplete: () => {
				scroll.start()
				resolve()
				gsap.to(loader, { duration: 1, autoAlpha: 0, ease: 'cubic-1' })
			} })
			/* gsap.to(text, { duration: 2, width: textW + 'px', ease: 'cubic-1', onComplete: () => {
				scroll.start()
				resolve()
				gsap.to(loader, { duration: 1, autoAlpha: 0, ease: 'cubic-1' })
			} }) */
		}})

		/* let text = loader.querySelector('.text');

		logo.innerHTML = Loader1SVG;
		text.innerHTML = Loader2SVG;

		let textW = text.getBoundingClientRect().width;
		gsap.to(text, { duration: 0, width: 0 })

		gsap.to(loader, { duration: 3, backgroundColor: '#f3f3f1', ease: 'cubic-1'})
		gsap.to(logo, { duration: 1, scale: 1, autoAlpha: 1, ease: 'cubic-1', onComplete: () => {
			scroll.scrollTo(0, { immediate: true })
			scroll.stop()
			gsap.to(text, { duration: 2, width: textW + 'px', ease: 'cubic-1', onComplete: () => {
				scroll.start()
				resolve()
				gsap.to(loader, { duration: 1, autoAlpha: 0, ease: 'cubic-1' })
			} })
		}})
 */
		/* let pathPink = icon.querySelector('svg .st0')
		let pathWhite = icon.querySelector('svg .st1')
		let length = pathWhite.getTotalLength();
		
		pathWhite.style.strokeDasharray = length + ' ' + length;
		pathWhite.style.strokeDashoffset = length;

		gsap.fromTo(pathPink, { scale: 40, transformOrigin:"center" }, { duration: 2, scale: 1, transformOrigin:"center", ease: 'cubic-1' });
		gsap.to(pathWhite, { duration: 1.3, strokeDashoffset: 0, ease: 'cubic-1', onComplete: () => {
			scroll.scrollTo(0, { immediate: true })
			scroll.stop()
			gsap.to(pathWhite, { duration: 0.7, fill: '#f3f3f1', ease: 'cubic-1', onComplete: () => {
				scroll.start()
				resolve()
				gsap.to(loader, { duration: 1, autoAlpha: 0, ease: 'cubic-1' })
			}})
		}}) */
	})
}

export class CircleCanvas {
	constructor(container, strokeColor, isImageNeeded, noise){
		this.container = container;
		this.w = this.container.getBoundingClientRect().width;
		this.h = this.container.getBoundingClientRect().height;
		this.canvas, this.ctx;
		this.halfX = this.w * 0.5;
		this.halfY = this.h * 0.5;
		this.vertices = 100;
		this.radius = this.w * 0.4;
		this.time = 0;
		this.lines = [];
		this.point = {};
		this.strokeColor = strokeColor;
		this.simplex = createNoise2D();
		this.lineNumber = 1;// 2 per avere il contorno
		this.variation = noise;
		this.noise;
		this.delta = 0.1;
		this.zoom = 1;
		this.alpha = {opacity: 0.1};
		this.image;
		this.isImageNeeded = isImageNeeded
		this.init();
	}
	init() {
		/**
		 * big--circle = cerchio senza opacity e senza hover
		 * hoover--circle = cerchio con opacity e hover
		 */
		if(this.container.classList.contains('big--circle')){
			this.alpha.opacity = 1;
			this.vertices = 200;
		}
		if(this.isImageNeeded){
			this.image = new Image();
			this.image.src = this.container.dataset.image;
		}
		this.canvas = document.createElement('canvas');
		this.canvas.width = this.w;
		this.canvas.height = this.h;
		if(this.container.classList.contains('hoover--circle')){
			this.container.closest('.item--image').addEventListener('mouseenter', () => {
				gsap.to(this.alpha, {duration: 1, opacity: 1 })
			})
			this.container.closest('.item--image').addEventListener('mouseleave', () => {
				gsap.to(this.alpha, {duration: 1, opacity: 0.05 })
			})
		}
		this.ctx = this.canvas.getContext('2d');
		this.container.appendChild(this.canvas);
		let i, j;
		for(i = 0; i < this.lineNumber; i++){
			this.lines[i] = [];
			for(j = 0; j <= this.vertices; j++){
				this.point = {
					x: Math.cos(j/this.vertices*Math.PI * 2),
					y: Math.sin(j/this.vertices*Math.PI * 2)
				}
				this.point._x = this.point.x;
				this.point._y = this.point.y;
				this.lines[i][j] = this.point;
			}
		}
		this.raf()
	}
	raf() {
		this.time++;
		this.update();
		this.drawCircle();
		window.requestAnimationFrame(() => {
			this.raf();
		})
	}
	update(){
		let i, j;
		for(i = 0; i < this.lineNumber; i++){
			for(j = 0; j<= this.vertices; j++){

				//this.noise = this.simplex.noise2D(this.lines[i][j]._x + this.time/400 * (1 + i*this.delta), this.lines[i][j]._y + this.time/400 * (1 + i*this.delta))
				this.noise = this.simplex(this.lines[i][j]._x + this.time/240, this.lines[i][j]._y + this.time/240);

				this.lines[i][j].x = this.lines[i][j]._x*this.radius*(1 + i*this.delta) + this.noise*(1 + i*this.delta) * this.radius*this.variation;
				this.lines[i][j].y = this.lines[i][j]._y*this.radius*(1 + i*this.delta) + this.noise*(1 + i*this.delta) * this.radius*this.variation;
			}
		}
	}
	drawCircle(){
		this.ctx.clearRect(0, 0, this.w, this.h);
		this.ctx.strokeStyle = this.strokeColor;
		if(!this.isImageNeeded){
			this.ctx.fillStyle = this.hexToRGB(this.strokeColor, this.alpha.opacity);
		}
		let i, j;
		for(i = 0; i < this.lineNumber; i++){
			if(i == 0){
				if(this.isImageNeeded){
					this.ctx.save();
				}

				this.ctx.beginPath();
				this.ctx.moveTo(this.lines[i][0].x + this.halfX, this.lines[i][0].y + this.halfY);
				for(j = 1; j<= this.vertices; j++){
					this.ctx.lineTo(this.lines[i][j].x + this.halfX, this.lines[i][j].y + this.halfY);
					//this.ctx.stroke();
				}
				this.ctx.closePath();
				if(this.isImageNeeded){
					this.ctx.clip();
					this.ctx.drawImage(this.image, 0, 0, this.w, this.h);
					this.ctx.restore();
				}else{
					this.ctx.fill();
				}
			}else{
				this.ctx.beginPath();
				for(j = 1; j<= this.vertices; j++){
					this.ctx.moveTo(this.lines[i][j-1].x + this.halfX, this.lines[i][j-1].y + this.halfY);
					this.ctx.lineTo(this.lines[i][j].x + this.halfX, this.lines[i][j].y + this.halfY);
					//this.ctx.stroke();
				}
				this.ctx.closePath();
				this.ctx.stroke();
			}
		}
	}
	lerp (start, end, amt){
		return (start + (end - start) * amt)
	}
	hexToRGB(hex, alpha) {
    var r = parseInt(hex.slice(1, 3), 16),
        g = parseInt(hex.slice(3, 5), 16),
        b = parseInt(hex.slice(5, 7), 16);

    if (alpha) {
        return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
    } else {
        return "rgb(" + r + ", " + g + ", " + b + ")";
    }
	}
}

export const customScrollPage = () => {
	const customScroll = new Lenis({
		duration: 1.2,
		easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // https://www.desmos.com/calculator/brs54l4xou
		orientation: 'vertical', // vertical, horizontal
		gestureOrientation: 'vertical', // vertical, horizontal, both
		smoothWheel: true,
		wheelMultiplier: 1,
		smoothTouch: false,
		touchMultiplier: 30,
		infinite: false,
	})

	function raf(time) {
		customScroll.raf(time)
		requestAnimationFrame(raf)
	}
	requestAnimationFrame(raf)

	/* setTimeout(() => {
		customScroll.scrollTo(0, {
			immediate: true,
			force: true,
			lock: true,
			onComplete: () => console.log('dd')
		})
	}, 500) */;
	
	return customScroll
}

export class Header {
	constructor(scroll) {
		this.container = document.getElementById('container');
		this.header = document.querySelector('header');
		this.marquee = this.header.querySelector('.top .marquee')
		this.logo = this.header.querySelector('.bottom .logo')
		this.socials = this.header.querySelectorAll('.socials ul li a .icon')
		this.scroll = scroll;
		this.scrollbar;

		this.scrollbarProgress = 0;

		this.init()
	}
	init(){
		this.logo.innerHTML = LogoSVG
		this.createScrollbar()

		this.scroll.on('scroll', (e) => {
			this.scrollbarProgress = e.progress
			this.animateScrollbar()
		})

		if(this.marquee){
			this.setWidthBannerItems()
			const boxes = gsap.utils.toArray(this.marquee.querySelectorAll('.wrapper .item')),
    	loop = this.horizontalLoop(boxes, {paused: false, repeat: -1});
		}

		if(this.socials){
			this.socials.forEach((el) => {
				if(el.classList.contains('facebook')){
					el.innerHTML = FacebookSVG
				}
				if(el.classList.contains('instagram')){
					el.innerHTML = InstagramSVG
				}
			})
		}
	}
	setWidthBannerItems() {
		let el = this.marquee.querySelector('.wrapper .item');
		let wd = el.getBoundingClientRect().width
		let winW = window.innerWidth;
		let allRep = Math.round(winW/wd);
		for(let i = 0; i < allRep; i++){
			let elCloned = el.cloneNode(true);
			this.marquee.querySelector('.wrapper').appendChild(elCloned);
		}
		/* let bannerGap = 0; //100 = 10rem
		[...this.marquee.querySelectorAll('.wrapper .item')].forEach((item) => {
			let wd = item.getBoundingClientRect().width
			item.style.width = (wd + bannerGap) + 'px';
		}) */
	}
	horizontalLoop(items, config) {
		items = gsap.utils.toArray(items);
		config = config || {};
		let tl = gsap.timeline({repeat: config.repeat, paused: config.paused, defaults: {ease: "none"}, onReverseComplete: () => tl.totalTime(tl.rawTime() + tl.duration() * 100)}),
			length = items.length,
			startX = items[0].offsetLeft,
			times = [],
			widths = [],
			xPercents = [],
			curIndex = 0,
			pixelsPerSecond = (config.speed || 1) * 100,
			snap = config.snap === false ? v => v : gsap.utils.snap(config.snap || 1), // some browsers shift by a pixel to accommodate flex layouts, so for example if width is 20% the first element's width might be 242px, and the next 243px, alternating back and forth. So we snap to 5 percentage points to make things look more natural
			totalWidth, curX, distanceToStart, distanceToLoop, item, i;
			gsap.set(items, { // convert "x" to "xPercent" to make things responsive, and populate the widths/xPercents Arrays to make lookups faster.
			xPercent: (i, el) => {
				let w = widths[i] = parseFloat(gsap.getProperty(el, "width", "px"));
				xPercents[i] = snap(parseFloat(gsap.getProperty(el, "x", "px")) / w * 100 + gsap.getProperty(el, "xPercent"));
				return xPercents[i];
			}
		});
		gsap.set(items, {x: 0});
		totalWidth = items[length-1].offsetLeft + xPercents[length-1] / 100 * widths[length-1] - startX + items[length-1].offsetWidth * gsap.getProperty(items[length-1], "scaleX") + (parseFloat(config.paddingRight) || 0);
		for (i = 0; i < length; i++) {
			item = items[i];
			curX = xPercents[i] / 100 * widths[i];
			distanceToStart = item.offsetLeft + curX - startX;
			distanceToLoop = distanceToStart + widths[i] * gsap.getProperty(item, "scaleX");
			tl.to(item, {xPercent: snap((curX - distanceToLoop) / widths[i] * 100), duration: distanceToLoop / pixelsPerSecond}, 0)
				.fromTo(item, {xPercent: snap((curX - distanceToLoop + totalWidth) / widths[i] * 100)}, {xPercent: xPercents[i], duration: (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond, immediateRender: false}, distanceToLoop / pixelsPerSecond)
				.add("label" + i, distanceToStart / pixelsPerSecond);
			times[i] = distanceToStart / pixelsPerSecond;
		}
		
		return tl;
	}
	createScrollbar() {
		let scrollbar = document.createElement('div');
		let innerScrollbar = document.createElement('div');
		scrollbar.setAttribute('id', 'custom-scrollbar');
		innerScrollbar.classList.add('inner-scrollbar');

		scrollbar.appendChild(innerScrollbar);
		this.container.appendChild(scrollbar)
		this.scrollbar = document.getElementById('custom-scrollbar')
	}
	animateScrollbar(){
		//progress va da 0 a 1
		let percH = this.scrollbarProgress*window.innerHeight;
		this.scrollbar.querySelector('.inner-scrollbar').style.height = `${percH}px`
	}
}

export class mousePointer {
	constructor(){
		this.w = window.innerWidth;
		this.h = window.innerHeight;
		this.cursor = document.getElementById('cursor')
		this.mousePosition = {
			x: this.w/2,
			y: this.h/2
		};
		this.init();
	}
	init(){
		this.setMousePositon()
		this.updateCursorClass()
		window.addEventListener("mousemove", (e) => this.mouseMove(e));
	}
	setMousePositon(){
		gsap.to(this.cursor, { duration: 0.1, top: this.mousePosition.y, left: this.mousePosition.x, ease: 'cubic-1' })
	}
	mouseMove(event){
		this.mousePosition.x = event.clientX
		this.mousePosition.y = event.clientY
		this.setMousePositon()
	}
	updateCursorClass() {
		let c1 = document.getElementById('cursor')

		let class1 = document.querySelectorAll('.custom-cursor-hover');
		[...class1].forEach((el) => {
			el.addEventListener('mouseenter', () => { c1.classList.add('hover'); });
			el.addEventListener('mouseleave', () => { c1.classList.remove('hover'); });
		});
	}
}

export const insertSocializeIcon = () => {
	const random_item = (items) => {
		return items[Math.floor(Math.random()*items.length)];
	}
	//let icons = [HashSVG, HeartSVG, ThumbSVG];
	let icons = [HashSVG, HeartSVG];

	document.querySelector('.home-section-3 .wrapper .title .icon').innerHTML = random_item(icons)
}

export const insertMapIcon = () => {
	document.querySelector('.home-section-4 .wrapper .title .icon').innerHTML = MapSVG
}

export const footerFunctions = () => {
	document.querySelector('footer .newsletter .newsletter-title .icon').innerHTML = NewsletterSVG
	document.querySelector('footer .bottom .right .credits a').innerHTML = AwdSVG

	let newsletterPrivacyBlock = document.querySelector('footer .custom-checkbox')
	let check = document.getElementById('newsletter_privacy');
	check.addEventListener('change', (ev) => {
		if(ev.currentTarget.checked) {
			newsletterPrivacyBlock.classList.add('checked')
		}else{
			newsletterPrivacyBlock.classList.remove('checked')
		}
	})

	/* let radios = document.querySelectorAll('input[name="gender"]');
	[...radios].forEach((radio) => {
		radio.addEventListener('change', (ev) => {
			let cus = document.querySelectorAll('.custom-radio');
			[...cus].forEach((cu) => cu.classList.remove('checked'))
			if(ev.currentTarget.checked){
				ev.currentTarget.closest('li').querySelector('.custom-radio').classList.add('checked')
			}
		})
	}) */

	document.getElementById('signup_newsletter').addEventListener('click', () => {
		gsap.to(document.querySelector('.newsletter-box .loader'), { duration: 0.5, autoAlpha: 1, ease: 'power2.out'})
		let mail = document.getElementById('newsletter-mail');

		//let genderV = document.getElementsByName("gender");      
		//let gender = Array.from(genderV).find(radio => radio.checked);
		//console.log(gender)
		//let gender = Array.from(document.getElementsByName("gender")).find(r => r.checked).value;
		//let gender = document.querySelector('input[name="gender"]:checked').value;
		if(mail.value.trim() != '' && validateEmail(mail.value.trim()) && check.checked){
			var date = new Date();
			var current_date = date.getFullYear()+"-"+(date.getMonth()+1)+"-"+ date.getDate();
			var current_time = date.getHours()+":"+date.getMinutes()+":"+ date.getSeconds();
			let body = {
				"email_address": mail.value.trim(),
				"subscription": {
					"ip": document.getElementById('newsletter-ip').value.toUpperCase(),
					"status": "Subscribed"
				},
				"triggers": {
					"automation": true,
					"behaviors": false,
					"send_confirmation_email": true
				},
				"update_if_duplicate": false,
				"custom_fields": [
					{
						"id": 284358,
						"value": document.getElementById('newsletter-language').value.toUpperCase()
					},
					/* {
						"id": 284359,
						"value": gender.value
					} */
				]
			}
			fetch4DEMApi(body)
		}else{
			gsap.to(document.querySelector('.newsletter-box .loader'), { duration: 0.5, autoAlpha: 0, ease: 'power2.out'})
			if(mail.value.trim() == ''){
				gsap.to(document.querySelector('.newsletter-box .input .error.empty'), { duration: 0.3, autoAlpha: 1, ease: 'power2.out'})
				gsap.to(document.querySelector('.newsletter-box .input .error.empty'), { duration: 0.3, delay: 2, autoAlpha: 0, ease: 'power2.out'})
			}else if(!validateEmail(mail.value.trim())){
				gsap.to(document.querySelector('.newsletter-box .input .error.wrong'), { duration: 0.3, autoAlpha: 1, ease: 'power2.out'})
				gsap.to(document.querySelector('.newsletter-box .input .error.wrong'), { duration: 0.3, delay: 2, autoAlpha: 0, ease: 'power2.out'})
			}
			/* if(gender == undefined){
				document.querySelector('.newsletter-box .gender').classList.add('error');
				setTimeout(() => {
					document.querySelector('.newsletter-box .gender').classList.remove('error');
				}, 2000)
			} */
			if(!check.checked){
				document.querySelector('.newsletter-box .privacy').classList.add('error');
				setTimeout(() => {
					document.querySelector('.newsletter-box .privacy').classList.remove('error');
				}, 2000)
			}
		}
		
	})

	const fetch4DEMApi = (body, gender) => {
		axios.post('https://api.4dem.it/api/authenticate', {
			APIKey: "1e15-1fc5-e75c-2e1e-1bb4-b461-7e58-5d9f"
		})
		.then(function (res) {
			axios.post('https://api.4dem.it/api/recipients/89437/subscribe?token=' + res.data.token, body)
			.then(function (response) {
				/* if(gender == 'M'){
					axios.post(`https://api.4dem.it/api/recipients/89437/tags/86/contacts/${response.data}?token=${res.data.token}`).then((res2) => {
						//console.log(res2)
					}).catch(function (error2) {
						console.log(error2)
					})
				}else{
					axios.post(`https://api.4dem.it/api/recipients/89437/tags/87/contacts/${response.data}?token=${res.data.token}`).then((res2) => {
						//console.log(res2)
					}).catch(function (error2) {
						console.log(error2)
					})
				} */
				gsap.to(document.querySelector('.newsletter-box .loader .icon'), { duration: 0.5, autoAlpha: 0, ease: 'power2.out'})
				gsap.to(document.querySelector('.newsletter-box .loader .text'), { duration: 0.5, autoAlpha: 1, ease: 'power2.out'})
				gsap.to(document.querySelector('.newsletter-box .loader .success'), { duration: 0.5, autoAlpha: 1, ease: 'power2.out'})
			})
			.catch(function (error) {
				if(error.response.data.message.duplicate){
					body = {...body, update_if_duplicate: true}
					//console.log(body)
					axios.post('https://api.4dem.it/api/recipients/89437/subscribe?token=' + res.data.token, body).then((response) => {
						/* if(gender == 'M'){
							axios.delete(`https://api.4dem.it/api/recipients/89437/tags/87/contacts/${response.data}?token=${res.data.token}`)
							axios.post(`https://api.4dem.it/api/recipients/89437/tags/86/contacts/${response.data}?token=${res.data.token}`).then((res2) => {
								//console.log(res2)
							}).catch(function (error2) {
								console.log(error2)
							})
						}else{
							axios.delete(`https://api.4dem.it/api/recipients/89437/tags/86/contacts/${response.data}?token=${res.data.token}`)
							axios.post(`https://api.4dem.it/api/recipients/89437/tags/87/contacts/${response.data}?token=${res.data.token}`).then((res2) => {
								//console.log(res2)
							}).catch(function (error2) {
								console.log(error2)
							})
						} */

						gsap.to(document.querySelector('.newsletter-box .loader .icon'), { duration: 0.5, autoAlpha: 0, ease: 'power2.out'})
						gsap.to(document.querySelector('.newsletter-box .loader .text'), { duration: 0.5, autoAlpha: 1, ease: 'power2.out'})
						gsap.to(document.querySelector('.newsletter-box .loader .update'), { duration: 0.5, autoAlpha: 1, ease: 'power2.out'})
					})
				}
			});
		})
		.catch(function (error) {
			//gsap.to(that.newsletterLoad, { duration: 0.5, autoAlpha: 0, ease: 'cubic-1'})
			console.log('error', error);
		});
	}
	const validateEmail = (email) => {
		let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
	}
}

export const CanvasHome = () => {
	// track the mouse positions to send it to the shaders
	const mousePosition = new Vec2();
	// we will keep track of the last position in order to calculate the movement strength/delta
	const mouseLastPosition = new Vec2();

	const deltas = {
		max: 0,
		applied: 0,
	};

	// set up our WebGL context and append the canvas to our wrapper
	const curtains = new Curtains({
		container: "canvas",
		watchScroll: false, // no need to listen for the scroll in this example
		pixelRatio: Math.min(2.5, window.devicePixelRatio), // limit pixel ratio for performance
		production: true
	});

	// handling errors
	curtains.onError(() => {
		// we will add a class to the document body to display original images
		document.body.classList.add("no-curtains");
	}).onContextLost(() => {
		// on context lost, try to restore the context
		curtains.restoreContext();
	});

	// get our plane element
	const planeElements = document.getElementsByClassName("plane");

	// some basic parameters
	const params = {
		vertexShader: vs,
		fragmentShader: fs,
		widthSegments: 200,
		heightSegments: 200,
		texturesOptions: {
			anisotropy: 16, // set anisotropy to a max so the texture isn't blurred when the plane's rotated
		},
		uniforms: {
			resolution: { // resolution of our plane
				name: "uResolution",
				type: "2f", // notice this is an length 2 array of floats
				value: [planeElements[0].clientWidth, planeElements[0].clientHeight],
			},
			time: { // time uniform that will be updated at each draw call
				name: "uTime",
				type: "1f",
				value: 0,
			},
			mousePosition: { // our mouse position
				name: "uMousePosition",
				type: "2f", // again an array of floats
				value: mousePosition,
			},
			mouseMoveStrength: { // the mouse move strength
				name: "uMouseMoveStrength",
				type: "1f",
				value: 0,
			}
		}
	};

	// create our plane
	const simplePlane = new Plane(curtains, planeElements[0], params);

	// if there has been an error during init, simplePlane will be nulfl
	simplePlane.onReady(() => {
		// set a fov of 35 to reduce perspective (we could have used the fov init parameter)
		simplePlane.setPerspective(35);

		// apply a little effect once everything is ready
		deltas.max = 2;

		// now that our plane is ready we can listen to mouse move event
		const wrapper = document.querySelector(".homepage--image-full");

		wrapper.addEventListener("mousemove", (e) => {
			handleMovement(e, simplePlane);
		});

		wrapper.addEventListener("touchmove", (e) => {
			handleMovement(e, simplePlane);
		}, {
			passive: true
		});

	}).onRender(() => {
		// increment our time uniform
		simplePlane.uniforms.time.value++;

		// decrease both deltas by damping : if the user doesn't move the mouse, effect will fade away
		deltas.applied += (deltas.max - deltas.applied) * 0.02;
		deltas.max += (0 - deltas.max) * 0.01;

		// send the new mouse move strength value
		simplePlane.uniforms.mouseMoveStrength.value = deltas.applied;

	}).onAfterResize(() => {
		const planeBoundingRect = simplePlane.getBoundingRect();
		simplePlane.uniforms.resolution.value = [planeBoundingRect.width, planeBoundingRect.height];
	}).onError(() => {
		// we will add a class to the document body to display original images
		document.body.classList.add("no-curtains");
	});

	// handle the mouse move event
	function handleMovement(e, plane) {
		// update mouse last pos
		mouseLastPosition.copy(mousePosition);

		const mouse = new Vec2();

		// touch event
		if(e.targetTouches) {
			mouse.set(e.targetTouches[0].clientX, e.targetTouches[0].clientY);
		}
		// mouse event
		else {
			mouse.set(e.clientX, e.clientY);
		}

		// lerp the mouse position a bit to smoothen the overall effect
		mousePosition.set(
			curtains.lerp(mousePosition.x, mouse.x, 0.3),
			curtains.lerp(mousePosition.y, mouse.y, 0.3)
		);

		// convert our mouse/touch position to coordinates relative to the vertices of the plane and update our uniform
		plane.uniforms.mousePosition.value = plane.mouseToPlaneCoords(mousePosition);

		// calculate the mouse move strength
		if(mouseLastPosition.x && mouseLastPosition.y) {
			let delta = Math.sqrt(Math.pow(mousePosition.x - mouseLastPosition.x, 2) + Math.pow(mousePosition.y - mouseLastPosition.y, 2)) / 30;
			delta = Math.min(4, delta);
			// update max delta only if it increased
			if(delta >= deltas.max) {
				deltas.max = delta;
			}
		}
	}
}

export const CanvasLoader = () => {
	// track the mouse positions to send it to the shaders
	const mousePosition = new Vec2();
	// we will keep track of the last position in order to calculate the movement strength/delta
	const mouseLastPosition = new Vec2();

	const deltas = {
		max: 0,
		applied: 0,
	};

	// set up our WebGL context and append the canvas to our wrapper
	const curtains = new Curtains({
		container: "canvas",
		watchScroll: false, // no need to listen for the scroll in this example
		pixelRatio: Math.min(2.5, window.devicePixelRatio), // limit pixel ratio for performance
		production: true
	});

	// handling errors
	curtains.onError(() => {
		// we will add a class to the document body to display original images
		document.body.classList.add("no-curtains");
	}).onContextLost(() => {
		// on context lost, try to restore the context
		curtains.restoreContext();
	});

	// get our plane element
	const planeElements = document.getElementsByClassName("planeLoader");

	// some basic parameters
	const params = {
		vertexShader: vs2,
		fragmentShader: fs2,
		widthSegments: 20,
		heightSegments: 20,
		uniforms: {
			resolution: { // resolution of our plane
				name: "uResolution",
				type: "2f", // notice this is an length 2 array of floats
				value: [planeElements[0].clientWidth, planeElements[0].clientHeight],
			},
			time: { // time uniform that will be updated at each draw call
				name: "uTime",
				type: "1f",
				value: 0,
			},
			mousePosition: { // our mouse position
				name: "uMousePosition",
				type: "2f", // again an array of floats
				value: mousePosition,
			},
			mouseMoveStrength: { // the mouse move strength
				name: "uMouseMoveStrength",
				type: "1f",
				value: 0,
			}
		}
	};

	// create our plane
	const simplePlane = new Plane(curtains, planeElements[0], params);

    // if there has been an error during init, simplePlane will be null
    simplePlane.onReady(() => {
        // set a fov of 35 to reduce perspective (we could have used the fov init parameter)
        simplePlane.setPerspective(35);

        // apply a little effect once everything is ready
        deltas.max = 2;

        // now that our plane is ready we can listen to mouse move event
        const wrapper = document.getElementById("page-wrap");

        wrapper.addEventListener("mousemove", (e) => {
            handleMovement(e, simplePlane);
        });

        wrapper.addEventListener("touchmove", (e) => {
            handleMovement(e, simplePlane);
        }, {
            passive: true
        });

    }).onRender(() => {
        // increment our time uniform
        simplePlane.uniforms.time.value++;

        // decrease both deltas by damping : if the user doesn't move the mouse, effect will fade away
        deltas.applied += (deltas.max - deltas.applied) * 0.02;
        deltas.max += (0 - deltas.max) * 0.01;

        // send the new mouse move strength value
        simplePlane.uniforms.mouseMoveStrength.value = deltas.applied;

    }).onAfterResize(() => {
        const planeBoundingRect = simplePlane.getBoundingRect();
        simplePlane.uniforms.resolution.value = [planeBoundingRect.width, planeBoundingRect.height];
    }).onError(() => {
        // we will add a class to the document body to display original images
        document.body.classList.add("no-curtains");
    });

    // handle the mouse move event
	function handleMovement(e, plane) {
		// update mouse last pos
		mouseLastPosition.copy(mousePosition);

		const mouse = new Vec2();

		// touch event
		if(e.targetTouches) {
			mouse.set(e.targetTouches[0].clientX, e.targetTouches[0].clientY);
		}
		// mouse event
		else {
			mouse.set(e.clientX, e.clientY);
		}

		// lerp the mouse position a bit to smoothen the overall effect
		mousePosition.set(
			curtains.lerp(mousePosition.x, mouse.x, 0.3),
			curtains.lerp(mousePosition.y, mouse.y, 0.3)
		);

		// convert our mouse/touch position to coordinates relative to the vertices of the plane and update our uniform
		plane.uniforms.mousePosition.value = plane.mouseToPlaneCoords(mousePosition);

		// calculate the mouse move strength
		if(mouseLastPosition.x && mouseLastPosition.y) {
			let delta = Math.sqrt(Math.pow(mousePosition.x - mouseLastPosition.x, 2) + Math.pow(mousePosition.y - mouseLastPosition.y, 2)) / 30;
			delta = Math.min(4, delta);
			// update max delta only if it increased
			if(delta >= deltas.max) {
					deltas.max = delta;
			}
		}
	}
}

export const buttonsAnimation = () => {
	let buttons = document.querySelectorAll('.custom-button-animation');
	[...buttons].forEach((button) => {
		button.addEventListener('mouseenter', (e) => {
			let rect = button.getBoundingClientRect();
			let relX = e.pageX - rect.left;
			let relY = e.clientY - rect.top;
			button.querySelector('.circle').style.top = relY + 'px'
			button.querySelector('.circle').style.left = relX + 'px'
		})
		button.addEventListener('mouseout', (e) => {
			let rect = button.getBoundingClientRect();
			let relX = e.pageX - rect.left;
			let relY = e.clientY - rect.top;
			button.querySelector('.circle').style.top = relY + 'px'
			button.querySelector('.circle').style.left = relX + 'px'
		})
	})
}

export const arrowHome = () => {
	let posts = document.querySelectorAll('.home-section-3 .wrapper .images .item .inner-links .icon');
	[...posts].forEach((post) => {
		post.innerHTML = ArrowSVG;
	})
}